import { render, staticRenderFns } from "./MapCard.vue?vue&type=template&id=37b0dce2&scoped=true"
import script from "./MapCard.vue?vue&type=script&lang=js"
export * from "./MapCard.vue?vue&type=script&lang=js"
import style0 from "./MapCard.vue?vue&type=style&index=0&id=37b0dce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b0dce2",
  null
  
)

export default component.exports